import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../../hooks/reactQuery/useQueryState";
import { useStoreActions } from "../../../store/store-context";
export const useLegalTerms = function useLegalTerms() {
  let {
    refreshOnHookMount = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const {
    data: legalTerms,
    isLoading,
    isFetching
  } = useQueryState({
    queryKey: [QueryKeys.LegalTerms],
    queryFn: () => api.business.getLegalTerms(),
    keepDataFresh: true,
    refreshOnHookMount
  });
  return {
    legalTerms: legalTerms !== null && legalTerms !== void 0 ? legalTerms : [],
    isLoading,
    isFetching
  };
};